import { NgModule } from '@angular/core';
import { FlutterwaveAngularjsComponent } from './flutterwave-angularjs.component';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [FlutterwaveAngularjsComponent],
  imports: [
    CommonModule
  ],
  exports: [FlutterwaveAngularjsComponent]
})
export class FlutterwaveAngularjsModule { }
